import { Link } from "react-router-dom";
import { LIFE_CATEGORIES, WAYS } from "@/lib/lifeCategories";
import { ArrowRight } from "lucide-react";

export function LifeMenu({ onClose }) {
  return (
    <div
      data-testid="life-mega-menu"
      className="absolute left-0 right-0 top-full bg-[#0D0B10] border-b hairline shadow-2xl z-40 max-h-[80vh] overflow-auto"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10 grid grid-cols-12 gap-8">
        <div className="col-span-12 lg:col-span-3">
          <div className="eyebrow mb-4">LIFE</div>
          <p className="font-serif text-2xl leading-tight text-stone-200">
            Whatever you're about to spend money on, start here.
          </p>
          <Link to="/find" onClick={onClose} data-testid="life-menu-audit-cta"
            className="mt-6 inline-flex items-center gap-2 font-label text-xs tracking-widest bg-[#EF3340] text-white px-5 py-3 hover:bg-[#cc2a35] transition-colors">
            RUN AN AUDIT <ArrowRight className="w-3 h-3" />
          </Link>
        </div>

        <div className="col-span-12 lg:col-span-6">
          <div className="grid sm:grid-cols-2 gap-x-8 gap-y-5">
            {LIFE_CATEGORIES.map((c) => (
              <div key={c.slug}>
                <Link to={`/life/${c.slug}`} onClick={onClose} data-testid={`life-cat-${c.slug}`}
                  className="font-display text-sm tracking-tight text-stone-100 hover:text-[#EF3340] transition-colors block">
                  {c.name}
                </Link>
                <div className="mt-1 flex flex-wrap gap-x-2 gap-y-0.5">
                  {c.subs.slice(0, 6).map((s) => (
                    <Link key={s} to={`/find?q=${encodeURIComponent(s)}`} onClick={onClose}
                      className="font-label text-[10px] text-stone-500 hover:text-stone-200 transition-colors">
                      {s}
                    </Link>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="col-span-12 lg:col-span-3 lg:border-l hairline lg:pl-8">
          <div className="eyebrow mb-4">WAYS TO GET IT</div>
          <div className="grid grid-cols-1 gap-1.5">
            {WAYS.map((w) => (
              <Link key={w.label} to={w.to} onClick={onClose} data-testid={`way-${w.type.toLowerCase().replace(/\s+/g, "-")}`}
                className="group flex items-baseline justify-between border-b hairline py-1.5">
                <span className="font-label text-xs tracking-widest text-stone-200 group-hover:text-[#EF3340] transition-colors">{w.label}</span>
                <span className="font-serif text-[11px] text-stone-500 text-right max-w-[55%] leading-tight">{w.desc}</span>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
